import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Link, useHistory } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useHotkeys } from 'react-hotkeys-hook';
import {postSwitchStore} from "helpers/backend_helper"
import { clearLocalCache } from "helpers/cache_helper";
import { showSuccessToast } from "helpers/function_helper"

const StoresDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const history = useHistory()
  const [menu, setMenu] = useState(false)
  const [allStores, setAllStores] = useState([])

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const authUser = JSON.parse(localStorage.getItem("authUser"))
      const stores = authUser.stores
      setAllStores(stores)
    }
  }, [])

  useHotkeys('alt+s,option+s', ()=> {
    history.push('/add-sales');
  })

  async function swithStore(storeId){
    const resp = await postSwitchStore({
      key:storeId
    })
    if(resp && resp.id){
      await clearLocalCache()
      localStorage.setItem("authUser", JSON.stringify(resp))
      history.push("/dashboard")
    }
  }

  return (
    <React.Fragment>
      {allStores.length > 1 && 
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn noti-icon "
          tag="button"
          id="page-header-notifications-dropdown"
        >
          .
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 " right>
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> Stores </h6>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "150px" }}>
            {allStores.map((each,i)=> (
              <Link to="#" className="text-reset notification-item" key={"sk"+i} onClick={()=>swithStore(each.storeid)}>
                <div className="media">
                  <div className="avatar-xxs me-3">
                    <span className={"avatar-title rounded-circle font-size-10 "+each.clazz}>
                      {i+1}
                    </span>
                  </div>
                  <div className="media-body align-self-center shortcut-title">
                    {each.storename}
                  </div>
                  <div>
                    {each.storeaddress}
                  </div>
                </div>
              </Link>
            )
            )}
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
      }
    </React.Fragment>
  )
}

export default (StoresDropdown)

StoresDropdown.propTypes = {
  t: PropTypes.any
}